import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Review from "../../components/home/Review";
import Service from "../../components/home/Service";
import Blog from "../../components/home/Blog";
import Partners from "../../components/home/Partners";
import InquiryList from "../../components/home/InquiryList";
import Event1 from "../../components/home/Event1";
import Event2 from "../../components/home/Event2";

const Home = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.result === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Banner />
      <Event1 />
      <About />
      <Service />
      <Event2 />
      <Review />
      <Blog data={data} />
      <InquiryList />
      <Partners />
    </div>
  );
};

export default Home;
